import styled, {css} from 'styled-components';

export const StyledBox = styled.div`
  ${({light}) => css`
    ${light &&
    css`
      && .MuiInputLabel-root {
        color: #fff;
      }
      && .MuiTypography-root {
        color: #fff;
      }
    `}
  `}
`;
